import { render, staticRenderFns } from "./AccessDenyModal.vue?vue&type=template&id=6af808d8&scoped=true&"
import script from "./AccessDenyModal.vue?vue&type=script&lang=js&"
export * from "./AccessDenyModal.vue?vue&type=script&lang=js&"
import style0 from "./AccessDenyModal.vue?vue&type=style&index=0&id=6af808d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af808d8",
  null
  
)

export default component.exports